import React, { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import './newFormStyles.css';

const Register = () => {
      const[name,setName]=useState("")
       const[email,setEmail]=useState("")
       const[password,setPassword]=useState("")
       const[phone,setPhone]=useState("")
       const[address,setAddress]=useState("");
       const navigate=useNavigate();

       const adminRegister=(e)=>{
        e.preventDefault();
        axios.post(`https://backendsurgylife-1.onrender.com/register`,{
            name,
            email,
            password,
            phone,
            address,
        })

        .then((res)=>{
            alert("Admin Registered Successfully");
          navigate('/admin')
        })
        .catch((err)=>{
         alert("Error Registering admin:")
        })    

       }
  return (
   <div className="admin-container">
      <div className="form-container" style={{width: '450px', padding: '1.5rem 2rem', }}>
        <p className="form-title">Admin Register</p>
        <form className="login-form" onSubmit={adminRegister}>
          
          <div className="input-group" style={{marginBottom: '0.50rem'}}>
            <label htmlFor="name">Name</label>
            <input 
              type="text" 
              name="name" 
              id="name" 
              placeholder="Enter your name"
              value={name}
              onChange={(e)=>setName(e.target.value)}
              required
            />
          </div>

          <div className="input-group" style={{marginBottom: '0.50rem'}}>
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              name="email" 
              id="email" 
              placeholder="Enter your email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="input-group" style={{marginBottom: '0.50rem'}}>
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              name="password" 
              id="password" 
              placeholder="Enter your password"
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group" style={{marginBottom: '0.50rem'}}>
            <label htmlFor="phone">Phone</label>
            <input 
              type="text" 
              name="phone" 
              id="phone" 
              placeholder="Enter your phone number"
              value={phone}
              onChange={(e)=>setPhone(e.target.value)}
              required
            />
          </div>

          <div className="input-group" style={{marginBottom: '0.5rem'}}>
            <label htmlFor="address">Address</label>
            <input 
              type="text" 
              name="address" 
              id="address" 
              placeholder="Enter your address"
              value={address}
              onChange={(e)=>setAddress(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Register Admin
          </button>
          
        </form>
      </div>
    </div>
  )
}

export default Register
